var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframeContainer",staticClass:"h-full -mx-5 -my-3"},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPageLoader,"color":_vm.loaderColor},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('iframe',{staticClass:"w-full",class:{
      hidden: _vm.loaded === 0,
      block: _vm.loaded === 1,
    },staticStyle:{"overflow-y":"hidden"},style:({ height: _vm.iframeHeight }),attrs:{"frameborder":"0","src":_vm.iframeSrc},on:{"load":_vm.load}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }